import { z } from "zod";

import { failingSourceSchema } from "./failing-source-schema";
import { testResultStatusSchema } from "./test-result-status-schema";

export const testResultSchema = z.object({
	status: testResultStatusSchema,
	httpStatusCode: z.union([z.number(), z.string()]).nullable(),
	failingSource: failingSourceSchema,
	fullError: z.string(),
});

export type TestResult = z.infer<typeof testResultSchema>;
